<div class="addContainer">
  <!-- Boton de cerrar -->
  <button (click)="dialogRef.close()" aria-label="Close dialog" class="modal-close-button" mat-icon-button>
    <mat-icon>close</mat-icon>
  </button>

  <!-- Contenido -->
  <div mat-dialog-content>
    <table class="table table-bordered table-striped tabla-alertas">
      <thead>
      <tr>
        <th class="col-medicamento">Medicamento</th>
        <th>Tipo de alerta</th>
        <th class="col-text">Descripcion</th>
      </tr>
      </thead>
      <tbody>
        @for (alerta of data.alerts; track alerta) {
          @for (row of alerta.alerts; track row) {
            <tr>
              <td class="col-medicamento">
                <strong>
                  <span>{{ row.medicamento || alerta.title }}</span>
                </strong>
              </td>
              <td>
                <span class="tipo-alerta"
                      [ngClass]="{
                    'badge-posologia': row.title?.toLowerCase().includes('posologia'),
                    'badge-alergia': row.title?.toLowerCase().includes('alergia'),
                    'badge-duplicidad': (
                      row.title?.toLowerCase().includes('duplicidad') ||
                      row.title?.toLowerCase().includes('ingrediente activo')
                    ),
                    'badge-otra': !(
                      row.title?.toLowerCase().includes('posologia') ||
                      row.title?.toLowerCase().includes('alergia') ||
                      row.title?.toLowerCase().includes('duplicidad') ||
                      row.title?.toLowerCase().includes('ingrediente activo')
                    )
                  }">

                  <!-- Icono Posologia -->
                  <svg
                    *ngIf="row.title?.toLowerCase().includes('posologia')"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 384 512"
                    class="icono-alerta"
                  >
                    <path
                      fill="currentColor"
                      d="M0 32C0 14.3 14.3 0 32 0L352 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64L0 32zm32 96l320 0 0 320c0 35.3-28.7 64-64 64L96 512c-35.3 0-64-28.7-64-64l0-320zM160 240l0 48-48 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z"
                    />
                  </svg>

                  <!-- Icono Alergia -->
                  <svg
                    *ngIf="row.title?.toLowerCase().includes('alergia')"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                    class="icono-alerta"
                  >
                    <path
                      fill="currentColor"
                      d="M96 352L96 96c0-35.3 28.7-64 64-64l256 0c35.3 0 64 28.7 64 64l0 197.5c0 17-6.7 33.3-18.7 45.3l-58.5 58.5c-12 12-28.3 18.7-45.3 18.7L160 416c-35.3 0-64-28.7-64-64zM272 128c-8.8 0-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16l-32 0zm24 336c13.3 0 24 10.7 24 24s-10.7 24-24 24l-160 0C60.9 512 0 451.1 0 376L0 152c0-13.3 10.7-24 24-24s24 10.7 24 24l0 224c0 48.6 39.4 88 88 88l160 0z"
                    />
                  </svg>

                  <!-- Icono Duplicidad y Redundancia ingrediente activo -->
                  <svg
                    *ngIf="
                      row.title?.toLowerCase().includes('duplicidad') ||
                      row.title?.toLowerCase().includes('ingrediente activo')
                    "
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 576 512"
                    class="icono-alerta"
                  >
                    <path
                      fill="currentColor"
                      d="M64 144c0-26.5 21.5-48 48-48s48 21.5 48 48l0 112-96 0 0-112zM0 144L0 368c0 61.9 50.1 112 112 112s112-50.1 112-112l0-178.4c1.8 19.1 8.2 38 19.8 54.8L372.3 431.7c35.5 51.7 105.3 64.3 156 28.1s63-107.5 27.5-159.2L427.3 113.3C391.8 61.5 321.9 49 271.3 85.2c-28 20-44.3 50.8-47.3 83l0-24.2c0-61.9-50.1-112-112-112S0 82.1 0 144zm296.6 64.2c-16-23.3-10-55.3 11.9-71c21.2-15.1 50.5-10.3 66 12.2l67 97.6L361.6 303l-65-94.8zM491 407.7c-.8 .6-1.6 1.1-2.4 1.6l4-2.8c-.5 .4-1 .8-1.6 1.2z"
                    />
                  </svg>

                  <!-- Otra alerta: Info Material Icon -->
                  <mat-icon class="icono-alerta"
                            *ngIf="!(
                      row.title?.toLowerCase().includes('posologia') ||
                      row.title?.toLowerCase().includes('alergia') ||
                      row.title?.toLowerCase().includes('duplicidad') ||
                      row.title?.toLowerCase().includes('ingrediente activo')
                    )">info</mat-icon>
                  {{ row.title?.split(':')[0] }}
                </span>
              </td>
              <td class="col-text">{{ row.description }}</td>
            </tr>
          }
        }
      </tbody>
    </table>
  </div>
</div>
